import { FC, CSSProperties } from 'react';
import { Severity } from '@agilelab/plugin-wb-governance-common';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import ErrorIcon from '@material-ui/icons/Error';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { WbBadge } from '../../WbBadge';
import { useStyles } from './style';

interface Props {
  severity?: Severity;
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const WarningIcon: FC<Props> = ({ severity, style, variant }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title={`Failed with severity ${
        severity ?? 'WARNING'
      }. This policy is just a warning, and will not block the deployment, but remember to check what errors made it fail`}
      icon={
        variant === 'reduced' ? (
          <span>
            <ErrorIcon
              className={`${classes.icon}`}
              htmlColor={theme.palette.warning.main}
              style={{ ...style, transform: 'scale(1.2)' }}
            />
          </span>
        ) : (
          <WbBadge
            color="warning"
            startIcon={<ReportProblemOutlinedIcon fontSize="small" />}
          >
            Warning
          </WbBadge>
        )
      }
    />
  );
};
